export default __webpack_public_path__ + "static/media/success-fulCases2.8d73d9a6.png";